import { PartModel } from './part.model';

export class MaterialStockLongTextModel {
    public constructor(
        public notificationNo: string,
        public taskNumber: string,
        public textId: string,
        public textLine: string,
    ) {}

    public static fromODataLTextModel(data: ODataLTextModel): MaterialStockLongTextModel {
        return new MaterialStockLongTextModel(data.NotificationNo, data.TaskNumber, data.TextId, data.TextLine);
    }
}

export class MaterialStockModel {
    public constructor(
        public partSet: PartModel[],
        public longTextInfo: MaterialStockLongTextModel[],
    ) {}

    public static fromODataMaterialStockModel(data: ODataMaterialStockModel[]): MaterialStockModel {
        const materialStockModel = data[0];
        const partSet = materialStockModel
            ? materialStockModel.MatStockAvailability.results.map((stockMaterial) => {
                  return PartModel.fromODataMatStockAvailabilityModel(stockMaterial);
              })
            : [];
        const longTextInfo = materialStockModel
            ? materialStockModel.MatStockLtext.results.map((longText) => {
                  return MaterialStockLongTextModel.fromODataLTextModel(longText);
              })
            : [];
        return new MaterialStockModel(partSet, longTextInfo);
    }
}

export interface ODataMaterialStockResponse {
    d: ODataMaterialStockResponseResults;
}

export interface ODataMaterialStockResponseResults {
    results: [ODataMaterialStockModel];
}

export interface ODataMaterialStockModel {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    FrontId: string;
    Material: string;
    StorageLoc: string;
    MatStockLtext: { results: ODataLTextModel[] };
    MatStockAvailability: { results: ODataMatStockAvailabilityModel[] };
}

export interface ODataLTextModel {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    NotificationNo: string;
    TaskNumber: string;
    TextId: string;
    TextLine: string;
}

export interface ODataMatStockAvailabilityModel {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    StorageLoc: string;
    Material: string;
    BatchNumber: string;
    MaterialDesc: string;
    Quantity: string;
    ExtUnit: string;
    NotificationNo: string;
    StorageLocDesc: string;
    LocalScrapReturnC: string;
    PONumber: string;
    ItemNumber: string;
    CustomerPrice: string;
    CustomerCurrency: string;
    LocalScrapReturnD: string;
    LocalScrapReturnV: string;
    LocalScrapReturnX: string;
    LsCrChangeable: string;
    SerialPIndicat: string;
    DangerousGoodsIndicator: string;
    HazardousMaterial: string;
    BatchNumberLegacy: string;
}
